var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangepasswordWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.824,
    height: 18.458,
    viewBox: "0 0 18.824 18.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_Password",
    "data-name": "Change Password",
    transform: "translate(-0.682 -1.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 18,
    height: 18,
    transform: "translate(1.247 1.297)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 0.481,
    cy: 0.481,
    r: 0.481,
    transform: "translate(16.302 4.941)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(6.915 6.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    d: "M13.56,9.96V8.408a1.8,1.8,0,0,0-2.024-1.3,1.7,1.7,0,0,0-1.746,1.3V9.96",
    transform: "translate(-8.297 -7.106)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1208-2",
    "data-name": "Rectangle_1208",
    d: "M8.669,11.02h5.448a.6.6,0,0,1,.649.514v3.947a.589.589,0,0,1-.649.514H8.669a.6.6,0,0,1-.649-.514V11.534a.589.589,0,0,1,.649-.514Z",
    transform: "translate(-8.02 -7.719)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    d: "M1.66,4.959,4.578,4.52l.439,2.918",
    transform: "translate(-0.108 -0.548)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    d: "M17.439,4.151A8.7,8.7,0,0,0,16.2,3.3,8.463,8.463,0,0,0,12.43,2.22",
    transform: "translate(-1.795 -0.188)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170-2",
    d: "M3.8,5.89,3.037,7.1a8.451,8.451,0,1,0,15.112.767",
    transform: "translate(-0.153 -0.763)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepasswordWhiteIcon);
export default __webpack_public_path__ + "static/media/changepassword-white-icon.86a5c494d284719b5c4f4e06ad5ee623.svg";
export { ForwardRef as ReactComponent };